import React from 'react';
import TuneIcon from '@material-ui/icons/Tune';
import HelpIcon from '@material-ui/icons/Help';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';

import '../styles/section.css';
import '../styles/tables.css';
import RespUtils from '../util/RespUtils';
import currentNetwork from '../currentNetwork';
import SessionUtils from '../util/SessionUtils';
import LogoUtils from '../util/LogoUtils';
import MainUtils from '../main/MainUtils';
import ValidatorUtils from './ValidatorUtils';


class StatusTagList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fullScreenMode: false,
    }
    this.handleFullScreen = this.handleFullScreen.bind(this);
  }

  render() {
    return (
        <div className="tablesBg">
            <div className="sectionHeader">
              <div className="sectionTitle">
                  <span>{this.renderStatusTags()} </span>
              </div>
              {this.renderFullScreenLink()}
            </div>
        </div>
    );
  }

  renderStatusTags() {
    if (this.props.renderFilters) {
      return this.props.renderFilters();
    }
    
    if (!this.props.statusSummary || currentNetwork.details.app.tendermint != true) {
      return "";
    }

    // console.log("in renderStatusTags");
    if (RespUtils.isTabletView()) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrlForAudit("/validators/All")}>{this.formatView("All ", (this.props.statusSummary.Total), "All")}</a> </td>
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/Bonded")}>{this.formatView("Bonded ", this.props.statusSummary.Bonded, "Bonded")}</a> </td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrlForAudit("/validators/All")}>{this.formatView("All ", (this.props.statusSummary.Total), "All")}</a> </td>
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/Bonded")}>{this.formatView("Bonded ", this.props.statusSummary.Bonded, "Bonded")}</a> </td>
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/Dec")}>{this.formatViewWithLabel("Decentralize ", "Dec")}</a> </td>
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/Perf")}>{this.formatViewWithLabel("> Avg Sign ", "Perf")}</a> </td>
          {currentNetwork.details.app.tendermint && (<td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/LowMaxRate")}>{this.formatView("Low Max Comm/Change Rate ", this.props.statusSummary.LowMaxRate, "LowMaxRate")}</a> </td>)}
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/CommIncrease")}>{this.formatView("Comm Increased ", this.props.statusSummary.CommIncrease, "CommIncrease")}</a> </td>
          {currentNetwork.details.app.enableIsNew === true && (<td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/New")}>{this.formatView("New ", this.props.statusSummary.New, "New")}</a> </td>)}
          <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/Jailed")}>{this.formatView("Jailed ", this.props.statusSummary.Jailed, "Jailed")}</a> </td>
          {currentNetwork.details.ui.badges.showBadges === true && currentNetwork.details.ui.badges.relayer === true && <td 
            className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/ibc")} title="Validators that run IBC relayers">
              <CompareArrowsIcon className="mInfoIcon" style={{fill: "white"}} fontSize="large"/>
            </a></td>}
          {currentNetwork.details.ui.badges.showBadges === true && currentNetwork.details.ui.badges.restake === true && 
            <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/restake")} title="Validators that run Restake App">
              {MainUtils.formatViewIcon("/images/restake.png", "valBadgeBorder")}
            </a></td>}
          {ValidatorUtils.renderBadge(currentNetwork.details.ui.badges.badge1Ind, "/validators/" + currentNetwork.details.ui.badges.badge1Key, 
            "Click to filter validator list for this provider", currentNetwork.details.ui.badges.badge1IndImg)}
          {ValidatorUtils.renderBadge(currentNetwork.details.ui.badges.badge2Ind, "/validators/" + currentNetwork.details.ui.badges.badge2Key, 
            "Click to filter validator list for this provider", currentNetwork.details.ui.badges.badge2IndImg)}
          {ValidatorUtils.renderBadge(currentNetwork.details.ui.badges.badge3Ind, "/validators/" + currentNetwork.details.ui.badges.badge3Key, 
            "Click to filter validator list for this provider", currentNetwork.details.ui.badges.badge3IndImg)}
          {currentNetwork.details.ui.badges.fdpInd === true && 
            <td className="view-tag"><a className="animLink" href={SessionUtils.getUrl("/validators/fdp")} 
              title="Validators receiving foundation delegation"> {LogoUtils.defaultChainLogo()}
            </a></td>}
        </tr></tbody></table></div>);
    }
  }

  formatView(label, count, status) {
    if (count !== null) {
      label = label + count;
    } else {
      label = label + "0";
    }

    return this.formatViewWithLabel(label, status)
  }

  formatViewWithLabel(label, status) {
    if (this.props.match && this.props.match.params.status) {
      if (this.props.match.params.status === status) {
        // console.log("status matched: ", this.props.match.params.status, status);
        return <b><u>{label}</u></b>
      } else {
        return label;
      }
    } else if (status === currentNetwork.details.app.defaultValidatorViewStatus) {
      // console.log("returning from AllEligible");
      return <b><u>{label}</u></b>
    } else if (status !== null) {
      // console.log("returning from status not null");
      return label;
    }

    // console.log("returning from end");
    return <b><u>{label}</u></b>
  }

  handleFullScreen() {
    RespUtils.handleFullScreen(this);
  }

  renderFullScreenLink() {
    if (this.state.fullScreenMode != true) {
      return <React.Fragment>
        <button onClick={this.props.showColumnSettings} className="tourColumnSettings animLinkMenu animLink"><TuneIcon /></button>
        {this.props.showHelp && <button onClick={this.props.showHelp} className="tourHelp animLinkMenu animLink"><HelpIcon /></button>}
        {RespUtils.renderFullScreenLink(this)}
      </React.Fragment>
    }
    return RespUtils.renderFullScreenLink(this);
  }
}

export default StatusTagList;
